import { ArrayDecoder, AutoEncoder, DateDecoder, EnumDecoder, field, NumberDecoder, StringDecoder } from '@simonbackx/simple-encoding';

export enum CustomerNotificationType {
    Promotion = "Promotion",
    Reminder = "Reminder",
    Account = "Account"
}

export enum NotificationPreference {
    Off = "Off",
    /**
     * @deprecated No longer offered in the app — muting sound is handled by the OS
     * notification settings. Kept so stored settings JSON and older clients still
     * decode; the backend treats Silent as Loud (see resolveNotificationPreference).
     */
    Silent = "Silent",
    Loud = "Loud"
}

export class CustomerNotificationPreferences extends AutoEncoder {
    @field({ decoder: new EnumDecoder(NotificationPreference) })
    promotion: NotificationPreference = NotificationPreference.Loud

    @field({ decoder: new EnumDecoder(NotificationPreference) })
    reminder: NotificationPreference = NotificationPreference.Loud

    @field({ decoder: new EnumDecoder(NotificationPreference) })
    account: NotificationPreference = NotificationPreference.Loud
}

export class CustomerNotificationResponse extends AutoEncoder {
    @field({ decoder: StringDecoder })
    id: string = ""

    @field({ decoder: new EnumDecoder(CustomerNotificationType) })
    type: CustomerNotificationType = CustomerNotificationType.Promotion

    @field({ decoder: StringDecoder })
    title: string = ""

    @field({ decoder: StringDecoder })
    body: string = ""

    @field({ decoder: StringDecoder, optional: true, nullable: true })
    promotionId: string | null = null

    @field({ decoder: DateDecoder })
    createdAt: Date = new Date()

    @field({ decoder: DateDecoder, optional: true, nullable: true })
    readAt: Date | null = null
}

export class CustomerNotificationsListResponse extends AutoEncoder {
    @field({ decoder: new ArrayDecoder(CustomerNotificationResponse) })
    notifications: CustomerNotificationResponse[] = []

    @field({ decoder: NumberDecoder })
    unread: number = 0
}

export class UnreadCountResponse extends AutoEncoder {
    @field({ decoder: NumberDecoder })
    unread: number = 0
}
